var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cluji-card',{attrs:{"title":_vm.title},on:{"collapse":_vm.onCollapse}},[(_vm.display)?_c('div',{staticClass:"chartContainer"},[(_vm.data.datasets)?_c(_vm.component,{tag:"component",attrs:{"chart-data":_vm.data}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }